// Tomahawk API client — JWT-aware fetch wrapper.
// Token lives in localStorage; client_id is derived server-side from it.
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export function getToken() {
  return localStorage.getItem("tmhk_token") || "";
}
export function setSession(token, clientId, name) {
  localStorage.setItem("tmhk_token", token);
  if (clientId) localStorage.setItem("tmhk_client_id", clientId);
  if (name) localStorage.setItem("tmhk_name", name);
}
export function clearSession() {
  localStorage.removeItem("tmhk_token");
  localStorage.removeItem("tmhk_client_id");
  localStorage.removeItem("tmhk_name");
}
export function isAuthed() {
  return !!getToken();
}

async function request(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth && getToken()) headers["Authorization"] = `Bearer ${getToken()}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    clearSession();
    if (typeof window !== "undefined") window.location.href = "/login";
    throw new Error("Sessão expirada");
  }
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new Error((data && data.detail) || `HTTP ${res.status}`);
  }
  return data;
}

export const api = {
  // auth
  signup: (b) => request("/auth/signup", { method: "POST", body: b, auth: false }),
  login: (b) => request("/auth/login", { method: "POST", body: b, auth: false }),
  me: () => request("/auth/me"),

  // personas
  listPersonas: () => request("/personas"),
  createPersona: (b) => request("/personas", { method: "POST", body: b }),
  getPersona: (id) => request(`/personas/${id}`),
  updatePersona: (id, b) => request(`/personas/${id}`, { method: "PUT", body: b }),
  deletePersona: (id) => request(`/personas/${id}`, { method: "DELETE" }),

  // places
  generatePlaces: (pid) => request(`/personas/${pid}/places/generate`, { method: "POST" }),
  listPlaces: (pid) => request(`/personas/${pid}/places`),

  // zones
  generateZones: (pid) => request(`/personas/${pid}/zones/generate`, { method: "POST" }),
  listZones: (pid) => request(`/personas/${pid}/zones`),

  // campaign plans
  generateCampaign: (zoneId) => request(`/zones/${zoneId}/campaign-plan`, { method: "POST" }),
  listCampaigns: (pid) => request(`/personas/${pid}/campaign-plans`),

  // performance
  recordPerformance: (planId, b) =>
    request(`/campaign-plans/${planId}/performance`, { method: "POST", body: b || {} }),
  listPerformance: (planId) => request(`/campaign-plans/${planId}/performance`),

  // activation (Meta)
  activateCampaign: (planId) => request(`/campaign-plans/${planId}/activate`, { method: "POST" }),

  // settings
  getSettings: () => request("/settings"),
  connectMeta: (b) => request("/settings/meta", { method: "POST", body: b }),
  disconnectMeta: () => request("/settings/meta", { method: "DELETE" }),
};
